namespace Portico.Services {
    import pm = Portico.Models;
    import pme = Portico.Models.Enterprise;
    import pmg = Portico.Models.Gateway;
    import pmi = Portico.Models.Interfaces;
    import psga = apigateway.client;
    import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IDocumentService {
        createPdf(documentName: string, templateData, title: string): angular.IPromise<any>;
        getById(documentId: number): angular.IPromise<psgm.DocumentModel>;
        upload(programId: number, typeId: number, file: any): angular.IPromise<pme.Document>;
    }

    @Service('app', 'documentService')
    @Inject('$q', 'Upload', 'serverConstants', 'DocumentV3Api')
    export class DocumentService implements IDocumentService {
        constructor(
            private $q: angular.IQService,
            private $upload: any,
            private serverConstants: pmi.IServerConstants,
            private documentApi: psga.DocumentV3Api
        ) {}

        createPdf(
            documentName: string,
            documentData: { [key: string]: string },
            title: string
        ): angular.IPromise<any> {
            const request: psgm.DocumentPdfDocumentModel = {
                documentGroupSource: pmg.DocumentGroupSource.TCPortal,
                documentGroupReceivedDate: moment(new Date().toJSON()),
                templateData: {
                    templateName: 'BaseDocumentTemplate',
                    author: 'Portico',
                    title: title || '',
                    overWriteExisting: false,
                    documentData: documentData || {},
                    documentStyles: [],
                },
                documentStatus: pmg.DocumentStatus.UNKN,
                documentOriginalFileName: documentName || '',
                faxAni: '',
                faxDns: '',
            };

            return this.$q.when(this.documentApi.pdfDocumentCreateByProgramId(request).then(response => {
                return response.data.data;
            }));
        }

        getById(documentId: number): angular.IPromise<psgm.DocumentModel> {
            return this.$q.when(this.documentApi.documentGetByProgramId(documentId).then(response => {
                response.data.data.createDate = <moment.Moment><unknown>response.data.data.createDate?.toDate();
                response.data.data.documentGroupReceivedDate = <moment.Moment><unknown>response.data.data.documentGroupReceivedDate?.toDate();
                response.data.data.lastUpdateDate = <moment.Moment><unknown>response.data.data.lastUpdateDate?.toDate();
                return response.data.data;
            }));
        }

        upload(programId: number, typeId: number, file: any): angular.IPromise<pme.Document> {
            return this.$upload
                .upload({
                    url:
                        this.serverConstants.root +
                        'File/UploadDocument/' +
                        programId +
                        '/' +
                        typeId,
                    data: { file: file },
                })
                .then(response => {
                    return new pme.Document(response.data);
                });
        }
    }
}
